"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils = require('../utils/utils');
var htmlparser = require('htmlparser2');
var domutils = require('domutils');
var twigTokenRegexp = '(({{\\s*contact.(?:label.|id.)?)([0-9]+)(.*?}})|' +
    '({%[^%}]*?contact.(?:label.|id.)?)([0-9]+)(.*?%}))';
exports.findPlaceholderPositions = function (template) {
    var placeHolderRegex = new RegExp('{# ' + utils.nonce + ' ([^#]+) #}(.*?){# ' + utils.nonce + ' #}', 'g');
    var match;
    var results = [];
    var lastMatchEnd = 0;
    while ((match = placeHolderRegex.exec(template)) !== null) {
        var start = template.indexOf(match[0], lastMatchEnd);
        lastMatchEnd = start + match[0].length;
        results.push({
            start: start,
            end: lastMatchEnd,
            data: utils.base64ToJson(match[1]),
            token: match[0],
            encoded: match[1],
            twig: match[2],
        });
    }
    return results;
};
exports.clearTokenMeta = function (template) {
    return exports.findPlaceholderPositions(template).reduceRight(function (templateToClear, _a) {
        var start = _a.start, end = _a.end, twig = _a.twig;
        return "" + templateToClear.substr(0, start) + twig + templateToClear.substr(end, templateToClear.length);
    }, template);
};
exports.replaceContactFieldsByMap = function (template, map) {
    var response = '';
    var handler = new htmlparser.DomHandler(function (error, dom) {
        if (error)
            console.log(error);
        else {
            dom.forEach(function (domElement) {
                distributeToken(domElement, map);
            });
        }
        response = domutils.getOuterHTML(dom);
    });
    var parser = new htmlparser.Parser(handler);
    parser.write(utils.wrapTemplate(template));
    parser.end();
    return utils.unwrapTemplate(response);
};
function distributeToken(element, map) {
    var newElement = null;
    if (utils.isV1Element(element)) {
        newElement = replaceContactFieldInV1Element(element, map);
    }
    if (utils.isV2Element(element)) {
        newElement = replaceContactFieldInV2Element(element, map);
    }
    if (utils.isStringElement(element)) {
        newElement = replaceContactFieldInStringElement(element, map);
    }
    if (newElement !== null) {
        domutils.replaceElement(element, newElement);
    }
    if (element.children && element.children.length > 0) {
        element.children.forEach(function (childrenElement) {
            distributeToken(childrenElement, map);
        });
    }
}
function replaceContactFieldInV1Element(element, map) {
    var field = element.attribs['e-personalization'];
    if (isFieldNeedToReplace(field, map)) {
        element.attribs['e-personalization'] = getNewFieldFromMap(field, map);
    }
    return element;
}
function replaceContactFieldInV2Element(element, map) {
    if (isContactToken(element)) {
        element.attribs['token-content'] = replaceTokenContentByMap(element, map);
        element.attribs['token-meta'] = replaceTokenMetaByMap(element, map);
    }
    return element;
}
function replaceContactFieldInStringElement(element, map) {
    var positions = exports.findPlaceholderPositions(element.data);
    var newTemplate = '';
    var lastCommentEnding = 0;
    positions.forEach(function (value) {
        var characterCount = value.start - lastCommentEnding;
        var nonCommentPart = element.data.substr(lastCommentEnding, characterCount);
        var replacedString = replaceContactFieldInSimpleTwig(nonCommentPart, map);
        var newToken = isTokenNeedToReplace(value.data.token, map)
            ? getNewToken(value, map)
            : value.token;
        lastCommentEnding = value.end;
        newTemplate += replacedString + newToken;
    });
    if (element.data.length > lastCommentEnding) {
        var characterCount = element.data.length - lastCommentEnding;
        var stringPart = element.data.substr(lastCommentEnding, characterCount);
        newTemplate += replaceContactFieldInSimpleTwig(stringPart, map);
    }
    element.data = newTemplate;
    return element;
}
function isContactToken(element) {
    var meta = JSON.parse(decodeURI(element.attribs['token-meta']));
    return meta.personalizationState.selectedTab === 'contact';
}
function isFieldNeedToReplace(field, map) {
    var row = map.find(function (item) { return item.old_id.toString() === field.toString(); });
    return row !== undefined;
}
function replaceContactFieldInSimpleTwig(nonCommentPart, map) {
    var fieldRegex = new RegExp(twigTokenRegexp, 'g');
    var match;
    var newString = '';
    var lastTwigEnding = 0;
    do {
        if ((match = fieldRegex.exec(nonCommentPart))) {
            var twig = match[0];
            var field = match[3] || match[6];
            var newField = getNewFieldFromMap(field, map);
            var twigStartIndex = match.index;
            var characterCount = twigStartIndex - lastTwigEnding;
            var replacedTwig = replaceFieldInTwig(twig, newField);
            newString +=
                nonCommentPart.substr(lastTwigEnding, characterCount) + replacedTwig;
            lastTwigEnding = twigStartIndex + twig.length;
        }
    } while (match);
    if (nonCommentPart.length > lastTwigEnding) {
        var characterCount = nonCommentPart.length - lastTwigEnding;
        newString += nonCommentPart.substr(lastTwigEnding, characterCount);
    }
    return newString;
}
function isTokenNeedToReplace(token, map) {
    return (token.source === 'contact' && isFieldNeedToReplace(token.content.field, map));
}
function getNewToken(value, map) {
    var newField = getNewFieldFromMap(value.data.token.content.field, map);
    var tokenWithReplacedHash = replaceHashInToken(value.token, value.data, newField, value.encoded);
    return replaceTwigInToken(tokenWithReplacedHash, value.twig, newField);
}
function getNewHash(data, targetField) {
    data.token.content.field = targetField.toString();
    data.preview = "{{ contact." + targetField + " }}";
    return utils.dataToBase64(data);
}
function replaceHashInToken(token, data, newField, oldHash) {
    var newHash = getNewHash(data, newField);
    return token.replace(oldHash, newHash);
}
function replaceTwigInToken(token, twig, newField) {
    var newTwig = replaceFieldInTwig(twig, newField);
    return token.replace(twig, newTwig);
}
function replaceFieldInTwig(twig, newField) {
    var fieldRegex = new RegExp(twigTokenRegexp, 'g');
    var match = fieldRegex.exec(twig);
    return match[2]
        ? match[2] + newField + match[4]
        : match[5] + newField + match[7];
}
function replaceTokenContentByMap(domElement, map) {
    var content = JSON.parse(decodeURI(domElement.attribs['token-content']));
    content.template = replaceContactFieldInSimpleTwig(content.template, map);
    return encodeURI(JSON.stringify(content));
}
function replaceTokenMetaByMap(domElement, map) {
    var meta = JSON.parse(decodeURI(domElement.attribs['token-meta']));
    var oldCOntactField = meta.personalizationState.selectedContent.selectedField.split('.')[1];
    meta.personalizationState.preview = replaceContactFieldInSimpleTwig(meta.personalizationState.preview, map);
    meta.personalizationState.selectedContent.selectedField =
        'contact.' + getNewFieldFromMap(oldCOntactField, map);
    return encodeURI(JSON.stringify(meta));
}
function getNewFieldFromMap(oldFieldId, map) {
    var row = map.find(function (item) { return item.old_id.toString() === oldFieldId.toString(); });
    return row ? row.new_id : oldFieldId;
}
//# sourceMappingURL=token-distribution.js.map